import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Card, Row, Col, Input, Tooltip, Space, Select } from 'antd';
import { SearchIcon, AddIcon } from '@chakra-ui/icons';
import { FiAlertTriangle } from 'react-icons/fi';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import SubTaskModal from './SubTaskModal';
import { RotateCw } from 'lucide-react';
import { RedoOutlined } from '@ant-design/icons';
import { createPortal } from 'react-dom';
import { Switch } from 'antd';


import { useDispatch } from 'react-redux';
import {
  RightOutlined,
  DownOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import { setTimelineEpicList } from 'store/actions';
import { setEpicTaskList } from 'store/actions';
import { setadminboardetails } from 'store/actions';
import SprintPopover from './SprintDetail';

import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Flex,
  Text,
  Portal,
} from '@chakra-ui/react';
import { FilterOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import Select from 'react-dropdown-select';
import httpInjectorService from 'services/http-injector.service';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
  FiMoreVertical,
  FiEdit,
  FiMoreHorizontal,
  FiDelete,
} from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
// import { useDispatch } from 'react-redux';
// import {settaskBoardDetails } from 'store/actions';
import { settaskBoardDetails } from 'store/actions';
import { settaskstatuscount } from 'store/actions';
import { setTaskstatuslist } from 'store/actions';
import { setassigneelist } from 'store/actions';
import SkeletonWithLoaders from 'components/common/Spinner';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from '@chakra-ui/react';
import { MdOutlinePerson, MdOutlineCalendarToday } from 'react-icons/md';
import { toast } from 'react-toastify';
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
  DragOverlay,
  useDroppable,
  closestCenter,
  pointerWithin,
  rectIntersection,
} from '@dnd-kit/core';
import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
// import TaskModal from '../TaskManagement/TaskModal';
import TaskCard from './TaskCard';
import TaskModal from './TaskModal';
import OptionModal from './OptionMenu';
import OptionMenu from './OptionMenu';
import EmployeeFilterMenu from './Employeelist';
import { horizontalListSortingStrategy } from '@dnd-kit/sortable';
import SprintModal from './Sprintmodal';
import UserAvatar from '../../../../components/userAvatar/index';
import CompleteSprintModal from './CompleteSprintModal';
import FilterDropdownPanel from './Filter';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Deletestatus from './Deletestatus';
import EpicList from './EpicList';
import { unparse } from 'papaparse';
const findColumn = (tasks, id) =>
  Object.keys(tasks).find((col) => tasks[col].some((t) => t.id === id));
const roleId = Number(Cookies.get('task-role-id'));

const canDragTask = [1, 2, 3].includes(roleId);

const DroppableColumn = ({
  columnKey,
  columnId,
  onDeleteColumn,
  tasks,
  taskCount,
  epicId,
  renderCreate,
  hovered,
  onHover,
  assigneeList,
  onOpenModal,
  handleOpenOptionMenu,

  updateHeight,
  getTaskBoardDetails,
  maxHeight,
  applyFilter,
}) => {
  const { setNodeRef } = useDroppable({
    id: columnId,
    data: { type: 'column', columnId },
  });

  const validTasks = Array.isArray(tasks) ? tasks.filter(Boolean) : [];

  const roleId = Number(Cookies.get('task-role-id'));

  return (
    <div
      ref={setNodeRef}
      style={{
        flex: 1,
        minWidth: '260px',
        maxWidth: '320px',
        height: maxHeight,
        display: 'flex',
        flexDirection: 'column',
        marginTop: -30,
      }}
    >
      <Card
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fafafa',
        }}
        bodyStyle={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        {/* header */}
        <div
          style={{
            padding: '10px 12px',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #ddd',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: 'whitesmoke',
          }}
        >
          <span>
            {columnKey} <span style={{ color: '#666' }}>({taskCount})</span>
          </span>
          {[1, 2].includes(roleId) && !['TO DO', 'DONE'].includes(columnKey) ? (
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<FiMoreHorizontal size={18} />}
                size="sm"
                variant="ghost"
                aria-label="Options"
              />
              <MenuList>
                <MenuItem
                  icon={<DeleteIcon color="red" boxSize={4} />}
                  onClick={() => onDeleteColumn(columnId, columnKey)}
                >
                  Delete
                </MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <IconButton
              icon={<FiMoreHorizontal size={18} />}
              size="sm"
              variant="ghost"
              aria-label="Options"
              style={{ visibility: 'hidden' }}
            />
          )}
        </div>

        <div
          onMouseEnter={() => onHover(columnKey)}
          onMouseLeave={() => onHover(null)}
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <SortableContext
            id={columnId}
            items={validTasks?.map((t) => t.issue_id)}
            strategy={verticalListSortingStrategy}
          >
            {validTasks?.map((task) => (
              <div data-tour="task-card">
              <TaskCard
                key={task.issue_id}
                task={task}
                columnId={columnId}
                assigneeList={assigneeList}
                onOpenModal={onOpenModal}
                openOptionModal={handleOpenOptionMenu}
                getTaskBoardDetails={getTaskBoardDetails}
              />
              </div>
            ))}
            {renderCreate?.(columnKey, hovered === columnKey, epicId)}
          </SortableContext>
        </div>
      </Card>
    </div>
  );
};

const DraggableColumnWrapper = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    data: {
      type: 'column',
      columnId: id,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    cursor: 'grab',
    width: '320px',
    flexShrink: 0,
    height: '100%',
  };

  return (
    <div ref={setNodeRef} {...attributes} {...listeners} style={style}>
      {children}
    </div>
  );
};

const TaskManagementAdminDashboard = ({ isAdminMode, setIsAdminMode }) => {
  // const [tasks, set] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [addingStatus, setAddingStatus] = useState(false);
  const [newStatusName, setNewStatusName] = useState('');
  const [columnOrder, setColumnOrder] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [creatingIn, setCreatingIn] = useState(null);
  const [newTitle, setNewTitle] = useState('');
  const [hoveredCol, setHoveredCol] = useState(null);
  const createRef = useRef(null);
  const employeePopoverRef = useRef(null);
  const datePopoverRef = useRef(null);
  const [dueDate, setDueDate] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  // const[assinedEmployee, setAssignedEmployee]=useState("");
  // const [assignedEmployee, setAssignedEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedType, setSelectedType] = useState('Task');
  // const [status, setStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [optionmodal, setOptionModal] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [optionMenuData, setOptionMenuData] = useState({
    task: null,
    anchorRef: null,
    isOpen: false,
    trigger: 0,
  });

  const [showsprintmodal, setshowSprintModal] = useState(false);
  const [recentlyCreatedTask, setRecentlyCreatedTask] = useState(null);
  const [epicList, setEpicList] = useState([]);
  //   const [epicArray, setEpicArray] = useState([]);
  const [openEpics, setOpenEpics] = useState([]);

  const [selectedEpic, setSelectedEpic] = useState(null);
  // const [taskStatusCount, setTaskStatusCount] = useState({});
  const [completesprintModal, setCompletesprintModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTasks, setFilteredTasks] = useState({});
  const [showdeletestatusmodal, Setdeletestatusmodal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [sprints, setSprints] = useState([]);
  const [exportdata, setExportdata] = useState(null);
  const [selectedfilterAssignee, setSelectedfilterAssignee] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [taskType, setTaskType] = useState('task');
  const [epicData, setEpicData] = useState([]);
  const [activeEpicId, setActiveEpicId] = useState(null);
  const [isNoEpicOpen, setIsNoEpicOpen] = useState(false);
    const [selectedTypeId, setSelectedTypeId] = useState(1);
 


  const [expandedEpicId, setExpandedEpicId] = useState(null);

  const [openEpicId, setOpenEpicId] = useState(null);

  const dispatch = useDispatch();
  const project_id = useParams();
  const dropdownRef = useRef(null);
  const getfilteredata = useSelector(
    (state) => state?.Authentication?.filteredBoard,
  );
  const tasks = useSelector((state) => state?.Authentication?.taskBoardDetails);

  const taskStatusCount = useSelector(
    (state) => state?.Authentication?.taskstatuscount,
  );

  const status = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const assignedEmployee = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );

  const getfilteredrequestbody = useSelector(
    (state) => state?.Authentication?.filteredrequestbody,
  );
 

  const EpicListdata = useSelector(
    (state) => state?.Authentication?.timelineepiclist || [],
  );

  const TimelinetaskList = useSelector(
    (state) => state?.Authentication?.epictasklist || [],
  );

  const BoardDetails = useSelector(
    (state) => state?.Authentication?.adminboardetails || [],
  );

  const isboardfilterApplied = useSelector(
    (state) => state?.Authentication?.isboardfilterApplied,
  );

  const [epicsState, setEpicsState] = useState({});

  useEffect(() => {
    if (!EpicListdata.length && !TimelinetaskList.length) return;

    const taskMap = {};

    TimelinetaskList.forEach((task) => {
      const epicId = task.epic_id ?? 'no-epic';
      if (!taskMap[epicId]) taskMap[epicId] = [];
      taskMap[epicId].push(task);
    });

    const groupedEpics = {};

    EpicListdata.forEach((epic) => {
      groupedEpics[epic.epic_id] = {
        epic_id: epic.epic_id,
        epic_name: epic.epic_name,
        epic_key: epic.epic_key,
        description: epic.description,
        start_date: epic.start_date,
        due_date: epic.due_date,
        epic_status: epic.epic_status,
        labels_id: epic.labels_id,
        epic_colour: epic.epic_colour,
        task_status_count: epic.issue_status_count,
        position: epic.position,
        tasks: taskMap[epic.epic_id] || [],
      };
    });

    if (taskMap['no-epic']) {
      groupedEpics['no-epic'] = {
        epic_id: 'no-epic',
        epic_name: 'No Epic',
        tasks: taskMap['no-epic'],
      };
    }

    setEpicsState(groupedEpics);
    dispatch(setadminboardetails(groupedEpics));
  }, [EpicListdata, TimelinetaskList]);

  const ISSUE_TYPE = [
      { id: 1, label: 'Task', value: 'Task', icon: TaskObject },
      { id: 2, label: 'Story', value: 'Story', icon: StoryObject },
      { id: 3, label: 'Bug', value: 'Bug', icon: BugObject },
    ];

  const roleId = Number(Cookies.get('task-role-id'));
  const [maxHeight, setMaxHeight] = useState(700);

  const updateHeight = (height) => {
    setMaxHeight((prev) => Math.max(prev, height));
  };

  const handleOpenOptionMenu = (task, anchorRef) => {
    setOptionMenuData((prev) => ({
      task,
      anchorRef: anchorRef.current,
      isOpen: true,
      trigger: prev.trigger + 1,
    }));
  };

  //   useEffect(() => {
  //     if (EpicListdata) {
  //       setEpicData(EpicListdata);
  //     }
  //   }, [EpicListdata]);
  // useEffect(() => {
  //   fetchEpicData();
  // }, [getfilteredrequestbody]);

   const filterKey = useMemo(() => {
    return JSON.stringify(getfilteredrequestbody);
  }, [getfilteredrequestbody]);

  useEffect(() => {
    if (!getfilteredrequestbody) return;
  
   fetchEpicData();
  }, [filterKey]);

  const toggleEpic = (epicId) => {
    setActiveEpicId(epicId);
    setOpenEpics((prev) =>
      prev.includes(epicId)
        ? prev.filter((id) => id !== epicId)
        : [...prev, epicId],
    );
  };

  // const fetchEpicData = async () => {
  //   const finalRequestBody = isFilterBodyEmpty(getfilteredrequestbody)
  //     ? { project_id: project_id.id }
  //     : getfilteredrequestbody;
  //   try {
  //     const response =
  //       await httpInjectorService.adminBoardDetails(finalRequestBody);
  //     if (response.status === 'success') {
  //       dispatch(setadminboardetails(response.data));
  //     }
  //   } catch (err) {
  //     throw err;
  //   }
  // };

 const fetchEpicData = async () => {
  const finalRequestBody = isFilterBodyEmpty(getfilteredrequestbody)
    ? { project_id: project_id.id }
    : getfilteredrequestbody;
  const isOnlyAssigneeFilter =
    finalRequestBody.assignee_id &&
    finalRequestBody.assignee_id.length > 0 &&
    (!finalRequestBody.epic_id || finalRequestBody.epic_id.length === 0) &&
    (!finalRequestBody.issue_status || finalRequestBody.issue_status.length === 0) &&
    (!finalRequestBody.issue_type_id || finalRequestBody.issue_type_id.length === 0) &&
    (!finalRequestBody.labels_id || finalRequestBody.labels_id.length === 0) &&
    (!finalRequestBody.sprint_id || finalRequestBody.sprint_id.length === 0);

  try {
    const response =
      await httpInjectorService.adminBoardDetails(finalRequestBody);
    if (response.status === "error") {
      if (isOnlyAssigneeFilter) {
        toast.success("No task assigned to this user");
      } else {
        toast.error(response.message);
      }
      dispatch(setadminboardetails([]));
      return;
    }

    if (response.status === "success") {
      const epics = response.data || [];

      const hasTasks = epics.some(
        (epic) => epic.issues && epic.issues.length > 0
      );

      if (!hasTasks) {
        if (isOnlyAssigneeFilter) {
          toast.success("No task assigned to this user");
        } else {
          toast.success("No task found");
        }
      }

      dispatch(setadminboardetails(epics));
    }
  } catch (err) {
    toast.error("Something went wrong");
    throw err;
  }
};

  function NoEpicSection({ isOpen, onToggle, children }) {
    return (
      <Box borderBottom="1px solid #E2E8F0" bg="#fff">
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          px={4}
          py={3}
          cursor="pointer"
          onClick={onToggle}
        >
          <Box mr={3}>{isOpen ? <DownOutlined /> : <RightOutlined />}</Box>

          <Text fontWeight="600" fontSize="15px">
            No Epic
          </Text>
        </Box>

        {/* Content */}
        {isOpen && (
          <Box pl={8} py={4} bg="#FAFAFA">
            {children}
          </Box>
        )}
      </Box>
    );
  }

  const epicArray = useMemo(() => {
    return Object.values(BoardDetails || {})
      .filter(Boolean)
      .sort((a, b) => {
        // handle missing position safely
        const posA = a.position ?? Number.MAX_SAFE_INTEGER;
        const posB = b.position ?? Number.MAX_SAFE_INTEGER;
        return posA - posB;
      });
  }, [BoardDetails]);

  const handleCloseOptionMenu = () => {
    setOptionMenuData((prevState) => {
      return {
        task: prevState.task,
        anchorRef: prevState.anchorRef,
        isOpen: false,
      };
    });
  };

  const handleOpenModal = (task) => {
    const simplifiedTask = {
      issue_id: task.issue_id,
      key: task.issue_key,
      title: task.issue_title,
      status: task.issue_status,
      priority: task.issue_priority,
      assignee_id: task.assignee_id,
      assignee_name: task.assignee_name,
      project_id: task.project_id,
      epic_id: task.epic_id,
      epic_name: task.epic_name,
      epic_key: task.epic_key,
      start_date: task.start_date,
      due_date: task.due_date,
      sprint_id: task.sprint_id,
      sprint_name: task.sprint_name,
      sprint_status: task.sprint_status,
      labels_id: task.labels_id,
      task: task,
    };

    setSelectedTask(simplifiedTask);
    setModalVisible(true);
  };

  const handleAssigneeClick = (user_id) => {
    setSelectedfilterAssignee((prev) => {
      let updated;
      if (prev.includes(user_id)) {
        updated = prev.filter((id) => id !== user_id);
      } else {
        updated = [...prev, user_id];
      }

      return updated;
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedTask(null);
  };

  const handleOptionModal = (task, anchorRef) => {
    setSelectedTask(task);
    setMenuAnchorEl(anchorRef);
    setOptionModal(true);
  };

  const handleOptionCloseModal = () => {
    setOptionModal(false);
    setSelectedTask(null);
    setMenuAnchorEl(null);
  };

  function TaskBoardContent({
    isLoading,
    columnOrder,
    status,
    filteredTasks,
    taskStatusCount,
    hoveredCol,
    setHoveredCol,
    assignedEmployee,
    epicId,
    renderCreate,
    handleOpenModal,
    updateHeight,
    handleOpenOptionMenu,
    openDeleteModal,
    getTaskBoardDetails,
    activeId,
    tasks,
    modalVisible,
    roleId,
    selectedTask,
    epicList,
    handleopensubtaskmodal,
    subtaskmodal,
    selectedSubtask,
    handleclosesubtaskmodal,
    optionMenuData,
    setOptionMenuData,
    showsprintmodal,
    setshowSprintModal,
    sprints,
    recentlyCreatedTask,
    project_id,
    showdeletestatusmodal,
    Setdeletestatusmodal,
    selectedStatus,
    listBoardStatus,
    completesprintModal,
    setCompletesprintModal,
  }) {
    return isLoading ? (
      <Flex justify="center" align="center" h="200px">
        <SkeletonWithLoaders />
      </Flex>
    ) : (
      <div style={{ position: 'relative', height: '100%' }} data-tour="kanban-board">
        <div style={{ flex: 1 }}>
          <div style={{ height: '100%', width: '100%' }}>
            <div style={{ height: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  padding: '8px',
                  height: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <SortableContext
                  items={columnOrder}
                  strategy={horizontalListSortingStrategy}
                >
                  {columnOrder.map((colId) => {
                    const statusObj = status.find((s) => s.id === colId);

                    const TASK_MIN_HEIGHT = 130;
                    const COLUMN_HEADER_HEIGHT = 300;
                    const COLUMN_PADDING = 16;

                    const tallestTaskCount = Math.max(
                      0,
                      ...Object.values(taskStatusCount || {}),
                    );

                    const maxHeight =
                      tallestTaskCount * TASK_MIN_HEIGHT +
                      COLUMN_HEADER_HEIGHT +
                      COLUMN_PADDING;

                    return (
                      <DraggableColumnWrapper key={colId} id={colId}>
                        <DroppableColumn
                          columnKey={statusObj?.status_name}
                          columnId={colId}
                          tasks={filteredTasks[statusObj?.status_name] || []}
                          taskCount={
                            taskStatusCount[statusObj?.status_name] || 0
                          }
                          epicId={epicId}
                          renderCreate={renderCreate}
                          hovered={hoveredCol}
                          onHover={setHoveredCol}
                          assigneeList={assignedEmployee}
                          onOpenModal={handleOpenModal}
                          updateHeight={updateHeight}
                          handleOpenOptionMenu={handleOpenOptionMenu}
                          onDeleteColumn={(statusId) =>
                            openDeleteModal(statusId, statusObj?.status_name)
                          }
                          getTaskBoardDetails={fetchEpicData}
                          maxHeight={maxHeight}
                        />
                      </DraggableColumnWrapper>
                    );
                  })}
                </SortableContext>

                <DragOverlay>
                  {activeId &&
                    (() => {
                      for (const statusKey in filteredTasks) {
                        const task = filteredTasks[statusKey]?.find(
                          (t) => String(t.issue_id) === String(activeId),
                        );
                        if (task) return <TaskCard task={task} />;
                      }
                      return null;
                    })()}
                </DragOverlay>

                {/* MODALS */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleAddStatus = async () => {
    const reqBody = {
      project_id: project_id.id,
      status_name: newStatusName,
    };

    try {
      const response = await httpInjectorService.addBoardstatus(reqBody);

      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setAddingStatus(false);
        setNewStatusName('');
        listBoardStatus(); // Refresh status columns
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error('Error adding status');
    }
  };

  const fetchTasksByEpicId = async (epicId) => {
    const queryParams = `?project_id=${project_id.id}&epic_id=${epicId}`;
    try {
      const response =
        await httpInjectorService.gettaskDetailsbyEpicId(queryParams);
      // 🔁 use your epic-specific API
      if (
        response.status === 'success' &&
        Array.isArray(response.data?.tasks)
      ) {
        const grouped = {};

        // Initialize groups by statuses
        status.forEach((s) => {
          grouped[s.status_name] = [];
        });

        response.data?.tasks.forEach((task) => {
          const simplifiedTask = {
            id: task.issue_id,
            title: task.task_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: task.epic_key,
            task_status: task.task_status,
            epic_name: task.epic_name,
            task,
          };

          if (grouped[task.task_status]) {
            grouped[task.task_status].push(simplifiedTask);
          }
        });

        // set(grouped);
        dispatch(settaskBoardDetails(grouped));
        if (response.data?.task_status_count) {
          // setTaskStatusCount(response.data.task_status_count);
          dispatch(settaskstatuscount(response.data.task_status_count));
        }
      } else {
        dispatch(settaskstatuscount({}));
        dispatch(settaskBoardDetails({}));
        // set({});
        // setTaskStatusCount({});
      }
    } catch (error) {
      throw error;
    }
  };

  const fetchTasksByAssigneeId = async (epicId) => {
    const queryParams = `?project_id=${project_id.id}&epic_id=${epicId}`;
    try {
      const response =
        await httpInjectorService.gettaskDetailsbyEpicId(queryParams);
      // 🔁 use your epic-specific API
      if (
        response.status === 'success' &&
        Array.isArray(response.data?.tasks)
      ) {
        const grouped = {};

        // Initialize groups by statuses
        status.forEach((s) => {
          grouped[s.status_name] = [];
        });

        response.data?.tasks.forEach((task) => {
          const simplifiedTask = {
            id: task.task_id,
            title: task.task_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: task.epic_key,
            task_status: task.task_status,
            task,
          };

          if (grouped[task.task_status]) {
            grouped[task.task_status].push(simplifiedTask);
          }
        });

        // set(grouped);
        dispatch(settaskBoardDetails(grouped));
        if (response.data?.task_status_count) {
          // setTaskStatusCount(response.data.task_status_count);
          dispatch(settaskstatuscount(response.data.task_status_count));
        }
      } else {
        dispatch(settaskstatuscount({}));
        dispatch(settaskBoardDetails({}));
        // set({});
        // setTaskStatusCount({});
      }
    } catch (error) {
      throw error;
    }
  };

  const isFilterBodyEmpty = (body) => {
    if (!body) return true;

    return (
      (!body.assignee_id || body.assignee_id.length === 0) &&
      (!body.epic_id || body.epic_id.length === 0) &&
      (!body.labels_id || body.labels_id.length === 0) &&
      (!body.sprint_id || body.sprint_id.length === 0) &&
      (!body.issue_type_id || body.issue_type_id.length === 0) &&
      (!body.issue_status || body.issue_status.length === 0)
    );
  };

  const getTaskBoardDetails = async () => {
    try {
      const finalRequestBody = isFilterBodyEmpty(getfilteredrequestbody)
        ? { project_id: project_id.id }
        : getfilteredrequestbody;

      const response =
        await httpInjectorService.adminBoardDetails(finalRequestBody);
       

      if (response.status === 'success') {
        const grouped = {};

        status?.forEach((s) => {
          grouped[s.status_name.toUpperCase()] = [];
        });

        let tasks = [];

        // Case A → Flat tasks
        if (Array.isArray(response.data?.tasks)) {
          tasks = response.data.tasks.map((task) => ({
            ...task,
            epic_name: task.epic_name,
            epic_key: task.epic_key,
          }));
        }

        // Case B → Epics with tasks
        else if (Array.isArray(response.data?.epics)) {
          response.data.epics.forEach((epic) => {
            (epic.tasks || []).forEach((task) => {
              tasks.push({
                ...task,
                epic_name: epic.epic_name,
                epic_key: epic.epic_key,
              });
            });
          });
        }

        tasks.forEach((task) => {
          const simplifiedTask = {
            id: task.issue_id,
            issue_type_id: task.issue_type_id,
            issue_type: task.issue_type,
            title: task.issue_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: task.epic_key,
            epic_name: task.epic_name,
            task_status: task.issue_status,
            subtasks_count: {
              total: task.subtask_count?.total ?? 0,
              done: task.subtask_count?.done ?? 0,
            },
            task,
          };

          const key = task.issue_status?.toUpperCase();

          if (grouped[key]) {
            grouped[key].push(simplifiedTask);
          } else {
            console.warn('Unmapped task status:', key);
          }
        });
      
        dispatch(settaskBoardDetails(grouped));

        if (response.data?.issue_status_count) {
          dispatch(settaskstatuscount(response.data.task_status_count));
        }
      } else {
       
        dispatch(settaskBoardDetails({}));
        dispatch(settaskstatuscount({}));
      }
    } catch (error) {
      throw error;
    }
  };
  const listBoardStatus = async () => {
    // setisLoading(true);
    try {
      const response = await httpInjectorService.ListBoardStatus(project_id.id);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        dispatch(setTaskstatuslist(statusList));
        // setStatus(statusList);
        // setColumnOrder(statusList?.map((s) => s.status_name)); // 👈 track order separately

        // Initialize empty task arrays dynamically
        const initialTasks = {};
        statusList?.forEach((s) => {
          initialTasks[s.status_name] = [];
        });
        dispatch(settaskBoardDetails(initialTasks));
        // setisLoading(false);
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));
        // setisLoading(false);
        // set({});
      }
    } catch (error) {
      throw error;
    }
  };

  const handleClearAllAssignee = () => {
    setSelectedfilterAssignee([]); // CLEAR PARENT STATE
  };

  const handleClear = () => {
    setSelectedfilterAssignee([]);
    // fetchEpicData();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideCard =
        createRef.current && !createRef.current.contains(event.target);
      const clickedOutsideEmployeePopover =
        employeePopoverRef.current &&
        !employeePopoverRef.current.contains(event.target);
      const clickedOutsideDatePopover =
        datePopoverRef.current &&
        !datePopoverRef.current.contains(event.target);

      if (
        clickedOutsideCard &&
        clickedOutsideEmployeePopover &&
        clickedOutsideDatePopover
      ) {
        setCreatingIn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [createRef, employeePopoverRef, datePopoverRef]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 1 } }),
  );

  const onDragStart = ({ active }) => {
    const { id, data } = active;
    const type = data?.current?.type;
    // 'epic' | 'column' | 'task'

    // --- EPIC DRAG ---
    if (type === 'epic') {
      if (![1, 2].includes(roleId)) {
        setActiveId(null);
        return;
      }
    }

    // --- COLUMN DRAG ---
    if (type === 'column') {
      if (![1, 2].includes(roleId)) {
        setActiveId(null);
        return;
      }
    }

    // --- TASK DRAG ---
    if (type === 'task') {
      if (![1, 2, 3].includes(roleId)) {
        setActiveId(null);
        return;
      }
    }

    setActiveId(id);
  };

  const handleopensubtaskmodal = (task) => {
    setSelectedSubtask(task);
    setSubtaskModal(true);
    setModalVisible(false);
  };

  const handleclosesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  const { epics, noEpic } = useMemo(() => {
    const values = Object.values(BoardDetails || {}).filter(Boolean);

    const query = searchQuery?.toLowerCase() || '';

    const epics = values
      .filter((e) => e.epic_id !== null)
      .filter((e) => !query || e.epic_name?.toLowerCase().includes(query))
      .sort((a, b) => {
        const posA = a.position ?? Number.MAX_SAFE_INTEGER;
        const posB = b.position ?? Number.MAX_SAFE_INTEGER;
        return posA - posB;
      });

    // 🔹 NO EPIC (UNCHANGED)
    const noEpic = values.find((e) => e.epic_id === null);

    return { epics, noEpic };
  }, [BoardDetails, searchQuery]);

  const allTasks = useMemo(() => {
    const epicTasks = epics.flatMap((e) => e.issue || e.issues || []);
    const noEpicTasks = noEpic?.issue || noEpic?.issues || [];
    return [...epicTasks, ...noEpicTasks];
  }, [epics, noEpic]);

  const onDragEnd = async ({ active, over }) => {
    setActiveId(null);
    if (!over) return;

    const activeId = active.id;
    const overId = over.id;
    const type = active.data?.current?.type;

    if (type === 'epic') {
      if (![1, 2].includes(roleId)) return;

      const oldIndex = epics.findIndex((e) => e.epic_id === activeId);
      const newIndex = epics.findIndex((e) => e.epic_id === overId);
      if (oldIndex === -1 || newIndex === -1) return;

      const updated = [...epics];
      const [movedEpic] = updated.splice(oldIndex, 1);
      updated.splice(newIndex, 0, movedEpic);
      dispatch(setadminboardetails(updated));

      const payload = {
        project_id: project_id.id,
        epics: updated.map((epic, index) => ({
          epic_id: epic.epic_id,
          position: index + 1,
        })),
      };

      try {
        await httpInjectorService.updateEpicposition(payload);
        fetchEpicData();
      } catch (err) {
        throw err;
      }
      return;
    }

    /* ===================== COLUMN REORDER ===================== */
    if (
      type === 'column' &&
      [1, 2].includes(roleId) &&
      columnOrder.includes(activeId) &&
      columnOrder.includes(overId)
    ) {
      const oldIndex = columnOrder.indexOf(activeId);
      const newIndex = columnOrder.indexOf(overId);
      if (oldIndex === -1 || newIndex === -1) return;

      const updated = [...columnOrder];
      updated.splice(oldIndex, 1);
      updated.splice(newIndex, 0, activeId);

      setColumnOrder(updated);

      const status_orders = updated
        .map((columnId, index) => {
          const match = status?.find((s) => s.id === columnId);
          return match ? { id: match.id, order: index + 1 } : null;
        })
        .filter(Boolean);

      try {
        await httpInjectorService.updateBoardStatusorder({
          project_id: project_id.id,
          status_orders,
        });
      } catch (err) {
        throw err;
      }
      return;
    }

    if (active.data?.current?.type === 'task') {
      const srcColumnId = active.data.current.columnId;

      const isOverTask = over?.data?.current?.type === 'task';
      const isOverColumn =
        over?.data?.current?.type === 'column' ||
        status.some((s) => s.id === over?.id);

      if (!isOverTask && !isOverColumn) {
        return;
      }
      const taskObj = allTasks.find((t) => t.issue_id === active.id);

      if (!taskObj) {
        return;
      }

      const issueTypeId = taskObj.issue_type_id;

      const destColumnId = isOverTask ? over.data.current.columnId : over.id; // ✅ columnId when empty

      const srcStatusObj = status.find((s) => s.id === srcColumnId);
      const destStatusObj = status.find((s) => s.id === destColumnId);

      if (!srcStatusObj || !destStatusObj) {
        return;
      }

      const srcKey = srcStatusObj.status_name;
      const destKey = destStatusObj.status_name;

      if (srcKey === destKey) {
        return;
      }

      try {
        await httpInjectorService.taskUpdateStatus({
          project_id: project_id.id,
          issue_id: active.id,
          issue_status: destKey.toUpperCase(),
          issue_type_id: issueTypeId,
        });
        fetchEpicData();
      } catch (err) {
        throw err;
      }
    }
  };

  const handleDateChange = (e) => {
    setDueDate(e.target.value);
    setShowDatePicker(false);
  };

  const createTask = async (col, epic_id, title) => {
    if (!title || !title.trim()) return;

    const trimmedTitle = title.trim();
    const tempId = Date.now();

    const tempTask = {
      id: tempId,
      title: trimmedTitle,
      status: col,
      assignee_id: selectedEmployee?.user_id ?? null,
      assignee_name: selectedEmployee?.username ?? null,
      epic_id,
    };

    // dispatch(
    //   setadminboardetails({
    //     ...tasks,
    //     [col]: [...(tasks[col] || []), tempTask],
    //   }),
    // );

    setCreatingIn(null);
    setSelectedEmployee(null);
    titleRef.current = '';

    const payload = {
      project_id: project_id.id,
      issue_title: trimmedTitle,
      issue_type_id: selectedTypeId,
      issue_type: selectedType,
      issue_status: col,
      due_date: dueDate || null,
      assignee_id: selectedEmployee?.user_id || null,
      epic_id,
    };

    try {
      const response = epic_id
        ? await httpInjectorService.addtaskwithEpic(payload)
        : await httpInjectorService.AddTaskWithoutEpic(payload);

      if (response.status === 'success') {
        setDueDate('');

        // fetchEpicData();

        setRecentlyCreatedTask(response.data);
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });

        setshowSprintModal(true);
        setSelectedType(null)
        setSelectedTypeId(null)
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response = await httpInjectorService.getProjectAssignedEmployeelist(
        project_id.id,
      );
      if (response.status === 'success') {
        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
      }
    } catch (error) {
      throw error;
    }
  };
  const handleEpicClick = (epicId) => {
    setOpenEpicId((prev) => (prev === epicId ? null : epicId));
  };

  const handleDeleteColumn = async (statusId, colKey) => {
    if (!statusId) return;
    const taskIds = (tasks[colKey] || []).map((task) => task.id);

    try {
      const reqBody = {
        project_id: project_id.id,
        status_name: colKey,
        status_id: statusId,
        task_ids: [...taskIds],
      };

      const response = await httpInjectorService.delete_status_column(reqBody);

      if (response.status === 'success') {
        listBoardStatus();
      } else {
        console.error('Failed to delete status:', response.message);
      }
    } catch (error) {
      throw error;
    }
  };

  const openDeleteModal = (statusId, colKey) => {
    setSelectedStatus({ id: statusId, colKey });
    Setdeletestatusmodal(true);
  };

  const getEpiclist = async () => {
    const queryParams = `?project_id=${project_id.id}`;
    // const projectId=project_id.id
    try {
      const response = await httpInjectorService.get_epic(queryParams);
      if (response.status === 'success') {
        setEpicList(response.data);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    setisLoading(true);
    fetchEpicData();
    listBoardStatus();
    getEpiclist();
    getprojectAssignedEmployee();
    getsprintlist();
    setisLoading(false);

    // handleExport();
  }, []);


const stripHtmlexportdata = (html) => {
  if (!html) return '';

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  return tempDiv.textContent
    ?.replace(/\u00A0/g, ' ') // remove &nbsp;
    ?.trim() || '';
};

  const handleExport = async () => {
    let reqbody = { project_id: project_id.id };

    try {
      const response = await httpInjectorService.exportTaskData(reqbody);

      if (response.status === 'success') {
        const { project, epics, tasks, subtasks } = response.data;

        // Merge all into one array with type
        const allData = [
  ...epics.map((i) => ({
    ...i,
    type: 'Epic',
    project: project.name,
    description:stripHtmlexportdata (i.epic_description),
    assignee: i.assignee || '',
  })),

  ...tasks.map((i) => ({
    ...i,
    type: 'Task',
    project: project.name,
    description:stripHtmlexportdata(i.issue_description),
    assignee: i.assignee || '',
  })),

  ...subtasks?.map((i) => ({
    ...i,
    type: 'Subtask',
    project: project.name,
    description: stripHtmlexportdata(i.subtask_description),
    assignee: i.assignee || '',
  })),
];


       
        // Create workbook & sheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Exported Data');

        // Define headers
        worksheet.columns = [
          { header: 'Project', key: 'project', width: 20 },
          { header: 'Key', key: 'key', width: 15 },
          { header: 'Type', key: 'type', width: 12 },
          { header: 'Parent', key: 'parent', width: 15 },
          { header: 'Summary', key: 'summary', width: 40 },
          {header: 'Description', key:'description', width:40},
          { header: 'Status', key: 'status', width: 15 },
          { header: 'Assignee', key: 'assignee', width: 20 },
          { header: 'Sprint', key: 'sprint', width: 20 },
          { header: 'Start Date', key: 'startDate', width: 15 },
          { header: 'Due Date', key: 'dueDate', width: 15 },
        ];

        allData.forEach((row) => worksheet.addRow(row));

        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF4472C4' },
          };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `${project.key}_export.xlsx`;
        saveAs(new Blob([buffer]), fileName);
      }
    } catch (error) {
      throw error;
    }
  };

  const stripHtml = (html = '') => html.replace(/<[^>]*>/g, '').toLowerCase();

  const matchesSearch = (task, epicName = '') => {
    if (!searchQuery?.trim()) return true;

    const query = searchQuery.toLowerCase();

    return (
      task?.issue_key?.toLowerCase().includes(query) ||
      task?.issue_title?.toLowerCase().includes(query) ||
      epicName?.toLowerCase().includes(query) ||
      stripHtml(task?.description).includes(query)
    );
  };

  const getEpicTasksData = (epic) => {
    const epicTasks = epic?.issue || epic?.issues || [];

    const epicName = epic?.epic_name || '';

    const searchedTasks = epicTasks.filter((task) =>
      matchesSearch(task, epicName),
    );

    const filteredTasks = searchedTasks.reduce((acc, task) => {
      const status = task.issue_status?.toUpperCase();
      if (!acc[status]) acc[status] = [];
      acc[status].push(task);
      return acc;
    }, {});

    const taskStatusCount = searchedTasks.reduce((acc, task) => {
      acc[task.issue_status] = (acc[task.issue_status] || 0) + 1;
      return acc;
    }, {});

    return { filteredTasks, taskStatusCount };
  };

  const noEpicTasks = noEpic?.issue || noEpic?.issues || [];

  const searchedNoEpicTasks = noEpicTasks.filter((task) => matchesSearch(task));

  const noEpicFilteredTasks = searchedNoEpicTasks.reduce((acc, task) => {
    const status = task.issue_status?.toUpperCase();
    if (!acc[status]) acc[status] = [];
    acc[status].push({
      ...task,
      data: {
        type: 'task',
        columnId: status,
      },
    });
    return acc;
  }, {});

  const noEpicTaskStatusCount = searchedNoEpicTasks.reduce((acc, task) => {
    acc[task.issue_status] = (acc[task.issue_status] || 0) + 1;
    return acc;
  }, {});

  useEffect(() => {
    const fetchData = async () => {
      if (status.length > 0) {
        setisLoading(true);

        setColumnOrder(status.map((s) => s.id));

        await getTaskBoardDetails();

        // await getEpiclist();

        setisLoading(false);
      }
    };

    fetchData();
  }, [status]);

  const handleCompleteSprint = () => {
    setCompletesprintModal(true);
  };

  const getsprintlist = async () => {
    try {
      const response = await httpInjectorService.getsprintList(project_id.id);
      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];
        setSprints(activeSprints); // 👈 only active sprints
      } else {
        toast({
          title: 'Error',
          description: response.message || 'Failed to fetch sprint list.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Something went wrong while fetching sprints.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const MAX_VISIBLE = 4;
  const visible = assignedEmployee.slice(0, MAX_VISIBLE);
  const hidden = assignedEmployee.slice(MAX_VISIBLE);
  const titleRef = useRef('');

  const renderCreate = (col, isHovered, epicId) => {
    if (creatingIn === col) {
      return (
        <div
          ref={createRef}
          style={{
            marginBottom: 16,
            position: 'relative',
            border: '1px solid #3399ff',
            padding: 8,
            background: '#fff',
            overflow: 'visible',
          }}
        >
          <div style={{ position: 'relative' }}>
            <textarea
              autoFocus
              defaultValue={titleRef.current}
              placeholder="What's need to be done?"
              style={{
                width: '100%',
                height: 120,
                border: 'none',
                outline: 'none',
                resize: 'none',
                paddingBottom: 40,
                boxSizing: 'border-box',
                fontSize: 14,
              }}
              onInput={(e) => {
                titleRef.current = e.target.value;
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  createTask(col, epicId, titleRef.current);
                  titleRef.current = '';
                }
              }}
            />

            <Box position="absolute" bottom="8px" left="3px" zIndex={10}>
              <Select
                            size="small"
                            value={selectedTypeId}
                            onChange={(value) => {
                              setSelectedTypeId(value);
                              const typeObj = ISSUE_TYPE.find((t) => t.id === value);
                              setSelectedType(typeObj?.label || '');
                            }}
                            style={{ width: 60 }}
                            optionLabelProp="label"
                            popupMatchSelectWidth={false}
                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                          >
                            {ISSUE_TYPE.map(({ id, label, icon: Icon }) => (
                              <Select.Option
                                key={id}
                                value={id}
                                label={Icon ? <Icon width={20} /> : label}
                              >
                                <div
                                  style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                                >
                                  {Icon && <Icon width={20} />}
                                  <span>{label}</span>
                                </div>
                              </Select.Option>
                            ))}
                          </Select>
            </Box>

            <Box
              position="absolute"
              bottom="8px"
              right="8px"
              display="flex"
              alignItems="center"
              gap={2}
              zIndex={10}
            >
              {/* Employee Popover */}
              <Popover
                isOpen={showEmployeePicker}
                onClose={() => setShowEmployeePicker(false)}
              >
                <PopoverTrigger>
                  <span
                    onClick={() => setShowEmployeePicker(!showEmployeePicker)}
                    style={{ cursor: 'pointer' }}
                  >
                    {selectedEmployee?.username ? (
                      <UserAvatar
                        username={selectedEmployee.username}
                        size={24}
                      />
                    ) : (
                      <MdOutlinePerson size={20} />
                    )}
                  </span>
                </PopoverTrigger>

                <Portal>
                  <PopoverContent ref={employeePopoverRef}>
                    <PopoverBody>
                      {assignedEmployee?.length > 0 ? (
                        <Box
                          maxH="200px"
                          overflowY="auto"
                          className="hide-scrollbar"
                        >
                          {assignedEmployee?.map((emp) => (
                            <Flex
                              key={emp.user_id}
                              align="center"
                              p="6px 10px"
                              borderRadius="6px"
                              cursor="pointer"
                              bg={
                                selectedEmployee?.user_id === emp.user_id
                                  ? '#e6f4ff'
                                  : 'transparent'
                              }
                              _hover={{ background: '#f0f0f0' }}
                              onClick={() => {
                                setSelectedEmployee(emp);
                                setShowEmployeePicker(false);
                              }}
                            >
                              <Box w="24px" h="24px" mr="8px">
                                <UserAvatar username={emp.username} size={24} />
                              </Box>
                              <Box fontSize="14px" color="#333">
                                {emp.username}
                              </Box>
                            </Flex>
                          ))}
                        </Box>
                      ) : (
                        <Box fontSize="12px" color="#888">
                          No employees found
                        </Box>
                      )}
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>

              {/* Date Picker Popover */}
              <Popover
                isOpen={showDatePicker}
                onClose={() => setShowDatePicker(false)}
              >
                <PopoverTrigger>
                  <span onClick={() => setShowDatePicker(!showDatePicker)}>
                    <MdOutlineCalendarToday
                      size={20}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                </PopoverTrigger>

                <Portal>
                  <PopoverContent width="auto" ref={datePopoverRef}>
                    <PopoverBody>
                      <Input
                        type="date"
                        value={dueDate}
                        onChange={handleDateChange}
                        size="sm"
                      />
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>

              {/* Create Button */}
              {/* <Button
                bg="#722ED1"
                color="white"
                size="xs"
                _hover={{ bg: '#5a1fb3' }}
                onClick={() => createTask(col)}
              >
                Create
              </Button> */}

              <Button
                bg="#722ED1"
                color="white"
                size="xs"
                _hover={{ bg: '#5a1fb3' }}
                onClick={() => createTask(col, epicId, titleRef.current)}
                data-tour="create-task"
              >
                Create
              </Button>
            </Box>
          </div>
        </div>
      );
    }

    if (isHovered) {
      return (
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          {[1, 2, 3].includes(roleId) && (
            <Button
              size="sm"
              variant="outline"
              leftIcon={<AddIcon />}
              onClick={() => setCreatingIn(col)}
            >
              Create
            </Button>
          )}
        </div>
      );
    }

    return null;
  };

  function SortableEpic({ epic, isOpen, onToggle, children, isCreating }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({
        id: epic.epic_id,
        data: { type: 'epic' },
      });

    const style = {
      transform: isCreating ? 'none' : CSS.Transform.toString(transform),
      transition: isCreating ? 'none' : transition,
    };

    return (
      <div ref={setNodeRef} style={style}>
        {/* Epic Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '14px 12px', // ⬅️ increases height
            minHeight: 48, // ⬅️ consistent row height
            background: '#fff',
            borderBottom: '1px solid #eee',
          }}
        >
          {/* Toggle button */}
          <span
            onClick={onToggle}
            style={{
              cursor: 'pointer',
              marginRight: 10,
              fontSize: 16, // ⬅️ icon size
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {isOpen ? <DownOutlined /> : <RightOutlined />}
          </span>

          <ThunderboltOutlined
            style={{
              color: '#884B9E',
              marginRight: 10,
              fontSize: 18, // ⬅️ icon size
            }}
          />

          {/* Epic title */}
          {/* <span
            {...attributes}
            {...listeners}
            style={{
              cursor: 'grab',
              flex: 1,
              fontSize: 15,
              fontWeight: 600,
              lineHeight: '20px',
            }}
          >
            {epic.epic_name} ({epic.task_status_count?.task_count || 0} Work
            Items)
          </span> */}
          <span
            {...attributes}
            {...listeners}
            style={{
              cursor: 'grab',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 15,
              fontWeight: 600,
              lineHeight: '20px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {/* Epic color */}
            <span
              style={{
                width: 14,
                height: 14,
                borderRadius: 3,
                backgroundColor: epic.epic_colour || '#8B5CF6',
                flexShrink: 0,
              }}
            />

            {/* Epic key */}
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#6B7280',
                flexShrink: 0,
              }}
            >
              {epic.epic_key}
            </span>

            {/* Epic name + count */}
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={epic.epic_name}
            >
              {epic.epic_name}{' '}
              <span style={{ color: '#6B7280', fontWeight: 500 }}>
                ({epic.issue_status_count?.issue_count || 0} Work Items)
              </span>
            </span>
          </span>
        </div>

        {isOpen && (
          <div style={{ paddingLeft: 24, paddingTop: 8 }}>{children}</div>
        )}
      </div>
    );
  }

  const handleEpicDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setEpicData((prev) => {
      const oldIndex = prev.findIndex((e) => e.epic_id === active.id);
      const newIndex = prev.findIndex((e) => e.epic_id === over.id);

      const reordered = arrayMove(prev, oldIndex, newIndex);

      return reordered.map((epic, index) => ({
        ...epic,
        position: index + 1,
      }));
    });
  };
  useEffect(() => {
    if (!Array.isArray(EpicListdata)) return;

    const sorted = [...EpicListdata]
      .map((e, index) => ({
        ...e,
        position: e.position ?? index + 1,
      }))
      .sort((a, b) => a.position - b.position);

    setEpicData(sorted);
  }, [EpicListdata]);

  const hasTasks = Object.values(tasks).some((col) => col.length > 0);

  return (
    <Card
      style={{
        position: 'fixed',
        top: '170px',
        left: '50px',
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* 🔒 Fixed Header */}

      <div
       style={{
    marginBottom: 14,
    marginTop: '10px',
    marginLeft: '30px',
    marginRight: '30px',
    display: 'flex',
    justifyContent: 'space-between', // 👈 important
    alignItems: 'center',
  }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {/* Left group - no space between first three columns */}

          <Input
            placeholder="Search Board"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            allowClear
            prefix={<SearchIcon color="gray.400" />}
            data-tour="board-search"
          ></Input>

          <Space style={{ position: 'relative', display: 'flex' }}>
            {visible.map((a, index) => {
              const isSelected = selectedfilterAssignee.includes(a.user_id);
              return (
                <Tooltip key={a.user_id} title={a.username}>
                  <div
                    onClick={() => handleAssigneeClick(a.user_id)}
                    style={{
                      border: isSelected
                        ? '2px solid #1677ff'
                        : '2px solid white',
                      borderRadius: '50%',
                      boxShadow: isSelected
                        ? '0 0 5px rgba(22,119,255,0.4)'
                        : 'none',
                      marginLeft: index === 0 ? 0 : -8,
                      cursor: 'pointer',
                      transition: '0.2s',
                      background: '#fff',
                    }}
                  >
                    <UserAvatar username={a.username} size={32} />
                  </div>
                </Tooltip>
              );
            })}

            {hidden.length > 0 && (
              <div
                ref={dropdownRef}
                style={{
                  position: 'relative',
                  display: 'inline-block',
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: '#f5f5f5',
                    color: '#555',
                    fontSize: 13,
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: -8,
                    cursor: 'pointer',
                    border: '2px solid white',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropdownOpen((prev) => !prev);
                  }}
                >
                  +{hidden.length}
                </div>

                {/* Custom popup menu */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 40,
                      right: 0,
                      width: 220,
                      maxHeight: 300,
                      overflowY: 'auto',
                      background: '#fff',
                      border: '1px solid #f0f0f0',
                      borderRadius: 8,
                      padding: 8,
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                      zIndex: 9999,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {hidden.map((a) => {
                      const isSelected = selectedfilterAssignee.includes(
                        a.user_id,
                      );
                      return (
                        <div
                          key={a.user_id}
                          onClick={() => handleAssigneeClick(a.user_id)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '8px',
                            borderRadius: 6,
                            background: isSelected
                              ? 'rgba(22,119,255,0.08)'
                              : 'transparent',
                            cursor: 'pointer',
                            marginBottom: 6,
                          }}
                        >
                          <UserAvatar username={a.username} size={24} />
                          <span style={{ flex: 1, fontSize: 13 }}>
                            {a.username}
                          </span>
                          {isSelected && (
                            <span
                              style={{
                                color: '#1677ff',
                                fontWeight: 700,
                              }}
                            >
                              ✓
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </Space>
          {selectedfilterAssignee.length > 0 && (
            <span
              onClick={handleClear}
              style={{
                cursor: 'pointer',
                color: '#1677ff',
                fontSize: 13,
                marginLeft: 8,
                textDecoration: 'underline',
              }}
            >
              Clear
            </span>
          )}
          <div data-tour="board-filter">
          <FilterDropdownPanel
            status={status}
            getTaskBoards={fetchEpicData}
            selectedfilterAssignee={selectedfilterAssignee}
            onAssigneeChange={setSelectedfilterAssignee}
            onClearAll={handleClear}
          />
          </div>
        </div>

        {/* <div style={{ display: 'flex', gap: 8 }}>
          {hasTasks && [1, 2].includes(roleId) && (
            <Col>
              <Button
                onClick={handleCompleteSprint}
                bg="#722ED1"
                color="white"
                size="sm"
                _hover={{ bg: '#5a1fb3' }}
              >
                Complete Sprint
              </Button>
            </Col>
          )}

          {[1, 2, 3].includes(roleId) && (
            <Button
              onClick={handleExport}
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
            >
              Export
            </Button>
          )}
        </div> */}
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          {hasTasks && [1, 2].includes(roleId) && (
            <Col>
              <Button
                onClick={handleCompleteSprint}
                bg="#722ED1"
                color="white"
                size="sm"
                _hover={{ bg: '#5a1fb3' }}
              >
                Complete Sprint
              </Button>
            </Col>
          )}

          <SprintPopover sprintList={sprints} roleId={roleId} />

          {[1, 2, 3].includes(roleId) && (
            <Button
              onClick={handleExport}
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
            >
              Export
            </Button>
          )}
         {roleId === 1 && (
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px 20px',
      background: '#fff',
    }}
  >
    <Switch
      checkedChildren="Admin"
      unCheckedChildren="Normal"
      checked={isAdminMode}
      onChange={setIsAdminMode}
    />
  </div>
)}

        </div>
      </div>

      <Card
        style={{
          position: 'fixed',
          top: '280px',
          left: '100px',
          right: '20px',
          bottom: '20px',
          overflowX: 'auto',
          overflowY: 'auto',
        }}
      >
        <Box w="100%">
          <DndContext
            sensors={sensors}
            collisionDetection={(args) => {
              // 1️⃣ Pointer is inside droppable (BEST)
              const pointerCollisions = pointerWithin(args);
              if (pointerCollisions.length > 0) {
                return pointerCollisions;
              }

              // 2️⃣ Fallback to rectangle intersection
              const rectCollisions = rectIntersection(args);
              if (rectCollisions.length > 0) {
                return rectCollisions;
              }

              // 3️⃣ Final fallback
              return closestCenter(args);
            }}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
          >
            <SortableContext
              items={epics?.map((e) => e.epic_id)}
              strategy={verticalListSortingStrategy}
            >
              {epics?.map((epic) => {
                const { filteredTasks, taskStatusCount } =
                  getEpicTasksData(epic);

                return (
                  <SortableEpic
                    key={epic.epic_id}
                    epic={epic}
                    isOpen={openEpics.includes(epic.epic_id)}
                    onToggle={() => toggleEpic(epic.epic_id)}
                    isCreating={creatingIn !== null}
                  >
                    {openEpics.includes(epic.epic_id) && (
                      <Box
                        pl={8}
                        py={4}
                        bg="#FAFAFA"
                        borderBottom="1px solid #E2E8F0"
                      >
                        <TaskBoardContent
                          isLoading={isLoading}
                          columnOrder={columnOrder}
                          status={status}
                          filteredTasks={filteredTasks}
                          taskStatusCount={taskStatusCount}
                          hoveredCol={hoveredCol}
                          setHoveredCol={setHoveredCol}
                          assignedEmployee={assignedEmployee}
                          epicId={epic.epic_id}
                          renderCreate={renderCreate}
                          handleOpenModal={handleOpenModal}
                          updateHeight={updateHeight}
                          handleOpenOptionMenu={handleOpenOptionMenu}
                          openDeleteModal={openDeleteModal}
                          getTaskBoardDetails={fetchEpicData}
                          activeId={activeId}
                          tasks={tasks}
                          modalVisible={modalVisible}
                          roleId={roleId}
                          selectedTask={selectedTask}
                          epicList={epicList}
                          handleopensubtaskmodal={handleopensubtaskmodal}
                          subtaskmodal={subtaskmodal}
                          selectedSubtask={selectedSubtask}
                          handleclosesubtaskmodal={handleclosesubtaskmodal}
                          optionMenuData={optionMenuData}
                          setOptionMenuData={setOptionMenuData}
                          showsprintmodal={showsprintmodal}
                          setshowSprintModal={setshowSprintModal}
                          sprints={sprints}
                          recentlyCreatedTask={recentlyCreatedTask}
                          project_id={project_id}
                          showdeletestatusmodal={showdeletestatusmodal}
                          Setdeletestatusmodal={Setdeletestatusmodal}
                          selectedStatus={selectedStatus}
                          listBoardStatus={listBoardStatus}
                          completesprintModal={completesprintModal}
                          setCompletesprintModal={setCompletesprintModal}
                        />
                      </Box>
                    )}
                  </SortableEpic>
                );
              })}
            </SortableContext>

            <NoEpicSection
              isOpen={isNoEpicOpen}
              onToggle={() => setIsNoEpicOpen((p) => !p)}
            >
              <TaskBoardContent
                isLoading={isLoading}
                columnOrder={columnOrder}
                status={status}
                filteredTasks={noEpicFilteredTasks}
                taskStatusCount={noEpicTaskStatusCount}
                hoveredCol={hoveredCol}
                setHoveredCol={setHoveredCol}
                assignedEmployee={assignedEmployee}
                epicId={null}
                renderCreate={renderCreate}
                handleOpenModal={handleOpenModal}
                updateHeight={updateHeight}
                handleOpenOptionMenu={handleOpenOptionMenu}
                openDeleteModal={openDeleteModal}
                getTaskBoardDetails={fetchEpicData}
                activeId={activeId}
                tasks={tasks}
                modalVisible={modalVisible}
                roleId={roleId}
                selectedTask={selectedTask}
                epicList={epicList}
                handleopensubtaskmodal={handleopensubtaskmodal}
                subtaskmodal={subtaskmodal}
                selectedSubtask={selectedSubtask}
                handleclosesubtaskmodal={handleclosesubtaskmodal}
                optionMenuData={optionMenuData}
                setOptionMenuData={setOptionMenuData}
                showsprintmodal={showsprintmodal}
                setshowSprintModal={setshowSprintModal}
                sprints={sprints}
                recentlyCreatedTask={recentlyCreatedTask}
                project_id={project_id}
                showdeletestatusmodal={showdeletestatusmodal}
                Setdeletestatusmodal={Setdeletestatusmodal}
                selectedStatus={selectedStatus}
                listBoardStatus={listBoardStatus}
                completesprintModal={completesprintModal}
                setCompletesprintModal={setCompletesprintModal}
              />
            </NoEpicSection>
            {modalVisible && [1, 2, 3, 4, 5].includes(roleId) && (
              <TaskModal
                isOpen={modalVisible}
                onClose={handleCloseModal}
                taskDetails={selectedTask}
                tasks={tasks}
                getTaskBoardDetails={fetchEpicData}
                EpicList={epicList}
                openSubtaskModal={handleopensubtaskmodal}
              />
            )}

            {subtaskmodal && selectedSubtask && (
              <SubTaskModal
                isOpen={subtaskmodal}
                subtaskdetails={selectedSubtask}
                onClose={handleclosesubtaskmodal}
                taskDetails={selectedTask}
                assigneeList={assignedEmployee}
              />
            )}

            {optionMenuData.anchorRef && (
              <OptionMenu
                anchorRef={optionMenuData.anchorRef}
                trigger={optionMenuData.trigger}
                onClose={() =>
                  setOptionMenuData((prev) => ({
                    ...prev,
                    isOpen: false,
                  }))
                }
                task={optionMenuData.task}
                status={status}
                getTaskBoardDetails={fetchEpicData}
              />
            )}

            {showsprintmodal && sprints?.length > 0 && (
              <SprintModal
                isOpen={showsprintmodal}
                onClose={() => setshowSprintModal(false)}
                taskdetails={recentlyCreatedTask}
                projectId={project_id.id}
                getTaskBoardDetails={fetchEpicData}
              />
            )}

            {showdeletestatusmodal && (
              <Deletestatus
                isOpen={showdeletestatusmodal}
                onClose={() => Setdeletestatusmodal(false)}
                selectedstatus={selectedStatus}
                projectId={project_id.id}
                statusList={status}
                listBoardStatus={listBoardStatus}
                tasks={tasks}
              />
            )}

            {completesprintModal && (
              <CompleteSprintModal
                isOpen={completesprintModal}
                onClose={() => setCompletesprintModal(false)}
                projectId={project_id.id}
                statusList={status}
                getTaskBoardDetails={fetchEpicData}
              />
            )}
          </DndContext>
        </Box>
      </Card>
    </Card>
  );
};

export default TaskManagementAdminDashboard;
